import { redirect } from "react-router";
import browserPaths from "details/navigation/browser/browserPaths";
import { useAuthStore } from "core/stores/authStore";

export default function firstLoginResetPasswordLoader() {
  if (!useAuthStore.getState().firstLoginPasswordReset) {
    return redirect(browserPaths.HOME);
  }
  return null;
}
